import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    var flashMessage = document.querySelector('#flash-messages');
    flashMessage.innerHTML = "";
    const auctionId = this.element.dataset.auctionId;
    if (sessionStorage.getItem('auction-' + auctionId)) {
      const savedValue = sessionStorage.getItem('auction-' + auctionId);
      const input = this.element.querySelector('#custom_val');
      if (input) input.value = savedValue;
    }
  }
}
